/**
 * Profile pane for portal settings — read-only account info managed by the admin.
 */
import { useQuery } from "@tanstack/react-query";
import { Label, Skeleton } from "@ddmarc/ui";
import { portalApi } from "@/lib/portal-api";
import { CardV2 } from "@/components/primitives";
import { cn } from "@/lib/utils";

export function ProfilePane() {
  const { data: user, isLoading } = useQuery({
    queryKey: ["portal", "profile"],
    queryFn: portalApi.getProfile,
  });

  return (
    <CardV2
      title="Profile"
      subtitle="Account information managed by your administrator."
    >
      {isLoading ? (
        <div className="space-y-3">
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
        </div>
      ) : (
        <dl className="grid grid-cols-1 gap-3 md:grid-cols-2">
          <Field label="Email" value={user?.email} mono />
          <Field label="Name" value={user?.name || "—"} />
          <Field label="Organization" value={user?.customer_name} />
          <Field label="Managed by" value={user?.msp_name} />
        </dl>
      )}
    </CardV2>
  );
}

function Field({
  label,
  value,
  mono,
}: {
  label: string;
  value: React.ReactNode;
  mono?: boolean;
}) {
  return (
    <div className="space-y-1">
      <Label className="text-[10.5px] font-semibold uppercase tracking-[0.05em] text-[var(--v2-fg-subtle)]">
        {label}
      </Label>
      <p
        className={cn(
          "text-[13px] text-foreground",
          mono && "font-mono-data"
        )}
      >
        {value}
      </p>
    </div>
  );
}
